/* eslint-disable react/no-deprecated */
import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import * as actions from '../../actions/index';
import { styles } from './MobileDesign.styles';
import {
  initStates,
  changeSwitchValue,
  changeSwitchValueMode,
  handleClick,
  getCommonBottomNavigationData
} from './MobileDesign.services';
import Paper from '../Paper';
import Spinner from '../Spinner';
import BackButton from '../BackButton';
import { marketing, mobileConfig, mainColor } from '../../constants';
import MobileDesignConfig from '../MobileDesignConfig';
import CommonBottomNavigation from '../CommonDesign/BottomNavigation/BottomNavigation.view';
import logoScreen from '../../assets/pictures/logoScreen.png';
import productScreen from '../../assets/pictures/productScreen.png';
import verticalOrientation from '../../assets/pictures/verticalOrientation.png';
import horizontalOrientation from '../../assets/pictures/horizontalOrientation.png';

function MobileDesign({ design, classes, history = {}, imageCoverOrderUrl }) {
  const [stateObj, setStateObjRaw] = useState({
    isLoading: true,
    selected: 0,
    selectedProduct: 0,
    title: '',
    config: ''
  });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });

  useEffect(() => {
    initStates(design, setStateObj);
  }, [design]);



  const renderStyle = () => {
    return (
      <div elevation={0}>
        <p className={classes.designText}>Design des étiquettes produits</p>
        <CommonBottomNavigation
          collection={getCommonBottomNavigationData(classes)}
          selectedMode={stateObj.selectedProduct}
          classes={classes}
          onChange={(event, newValue) => changeSwitchValueMode(newValue, setStateObj)}
          onCheck={() => setStateObj({ selectedProduct: stateObj.selectedProduct === 1 ? 0 : 1 })}
          idCheck='etiquetteCheck'
        />
      </div>
    );
  };

  const renderFirstStepDesign = () => {
    const sections = Object.values(mobileConfig);
    return (
      <div className='col-md-12'>
        <List>
          {_.map(sections, (config, index) => {
            return (
              <>
                <ListItem
                  key={index}
                  button
                  className={classes.gutters}
                  onClick={event => handleClick(event, index, setStateObj, config.text)}
                >
                  <ListItemIcon>{config.icon}</ListItemIcon>
                  <ListItemText
                    style={{ color: mainColor.colorBlack }}
                    primary={config.text}
                    secondary={<p className={classes.textStyle}>{config.description}</p>}
                  />
                  <ChevronRight style={{ color: mainColor.colorBlack }} />
                </ListItem>
                {index <= sections.length - 2 && <Divider component='li' />}
              </>
            );
          })}
        </List>
      </div>
    );
  };

  const renderConfig = () => {
    return (
      <div className='col-md-6 col-lg-5 col-xl-4'>
        <Paper elevation={1} className={classes.paperStyle}>
          {stateObj.config !== '' && (
            <>
              <List>
                <ListItem
                  button
                  className={classes.listStyle}
                  onClick={() =>
                    setStateObj({
                      config: ''
                    })
                  }
                >
                  <ListItemIcon>
                    {' '}
                    <ArrowBackIosOutlinedIcon style={{ color: mainColor.colorBlack }} />
                  </ListItemIcon>
                  <ListItemText
                    className={classes.configText}
                    primary={<p className={classes.configStyle}>Configuration générale</p>}
                    secondary={stateObj.title}
                  />
                  <SettingsOutlinedIcon className={classes.darkColor} />
                </ListItem>
              </List>
              <Divider />{' '}
            </>
          )}
          <MobileDesignConfig
            config={stateObj.config}
            selected={stateObj.selected}
            onClick={(event, newValue) => changeSwitchValue(newValue, imageCoverOrderUrl, setStateObj)}
            renderFirstStepDesign={renderFirstStepDesign()}
            renderStyle={renderStyle()}
            selectedProduct={stateObj.selectedProduct}
          />
        </Paper>
      </div>
    );
  };

  return (
    <div className='p-4'>
      <BackButton
        className='p-0'
        onClick={() => history.goBack()}
        title={marketing.mobileDesign.text}
        subtitle={marketing.mobileDesign.description}
      />
      {stateObj.isLoading ? (
        <center>
          <Spinner className={classes.progress} />
        </center>
      ) : (
        <div>
          <Paper className={`${classes.body} mt-2`}>
            <div className='row w-100 h-100'>
              <div className={`${classes.row} col-md-6 col-lg-7 col-xl-8 mb-2 mb-md-0 h-100`}>
                <div className={`d-none d-xl-flex ${classes.row}`}>
                  <div className={`d-none d-xl-flex  ${classes.heightImage}  pl-2`}>
                    <img src={stateObj.selected === 0 ? logoScreen : verticalOrientation} alt="" className={classes.coverImage} />
                  </div>
                  <div className={`d-none d-xl-flex  ${classes.heightImage}`}>
                    <img src={stateObj.selected === 0 ? productScreen : horizontalOrientation} alt="" className={classes.coverImage} />
                  </div>
                </div>
                <div className={`d-xl-none  ${classes.designStyle}`}>
                  <img
                    src={
                      stateObj.selected === 0
                        ? stateObj.config === 'Produits' || stateObj.config === 'Liens'
                          ? productScreen
                          : logoScreen
                        : stateObj.selectedProduct === 0
                          ? verticalOrientation
                          : horizontalOrientation
                    }
                    alt=''
                    className={`${classes.heightImage}`}
                  />
                </div>
              </div>
              {renderConfig()}
            </div>
          </Paper>
        </div>
      )}
    </div>
  );

}

function mapStateToProps({ firebaseRealTime }) {
  const { generalConfig = {} } = firebaseRealTime;
  const { mobileApp = {} } = generalConfig;
  const { design } = mobileApp;
  return {
    design
  };
}
MobileDesign.propTypes = {
  classes: PropTypes.element.isRequired
};
export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(MobileDesign)));
